<!-- src/components/GenericComponents/MicroNDA.vue -->
<template>
  <div class="micro-nda" :class="`micro-nda--${variant}`">
    <p v-if="variant === 'landing'" class="nda-text">
      Access to The33Path is restricted. What you are about to enter is a
      private universe containing unreleased stories, visual identities, and
      intellectual property still in active development. By requesting access,
      you agree to uphold confidentiality and not share, save, or disclose any
      material found within this website. A formal NDA will be required before
      entry.
    </p>

    <p v-else-if="variant === 'mainlongread'" class="nda-text">
      The stories, business structure, and brand identity within The33Path are
      meant to unfold gradually as part of the inner architecture of this
      universe. Sharing details of upcoming films, narrative arcs, character
      journeys, strategic structures, artefacts, or initiatory processes with
      those who do not have access to this space disrupts the experience and
      breaks the integrity of the journey for future participants. By
      continuing, you acknowledge this responsibility and agree to protect the
      coherence and confidentiality of what you encounter here.
    </p>

    <p v-else-if="variant === 'deeper'" class="nda-text">
      This is a protected layer of The33Path. The material in this section is
      restricted and confidential. Sharing details of upcoming films, narrative
      arcs, character journeys, strategic structures, artefacts, or initiatory
      processes with those who do not have access to this space disrupts the
      experience and breaks the integrity of the journey for future
      participants. By accessing it, you agree not to share, copy, disclose, or
      reproduce any part of what is presented here.
    </p>
  </div>
</template>

<script>
export default {
  name: "MicroNDA",
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) =>
        ["landing", "mainlongread", "deeper"].includes(value),
    },
  },
};
</script>

<style scoped>
.micro-nda {
  width: 100%;
  text-align: center;
}

.nda-text {
  color: var(--grey-lighter);
  font-size: var(--smallerFontSize);
  line-height: calc(var(--smallerFontSize) * 1.45);
  margin: var(--largeSpace) 0;
  opacity: 0.6;
}

/* Landing page variant - centered, max width */
.micro-nda--landing .nda-text {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 var(--space);
}

/* Main longread variant - readable width */
.micro-nda--mainlongread .nda-text {
  max-width: var(--maxWidth);
  margin: var(--doubleSpace) auto;
  padding: 0 var(--space);
}

/* Deeper layers variant - subtle background */
.micro-nda--deeper {
  margin: var(--doubleSpace) 0;
}

.micro-nda--deeper .nda-text {
  max-width: var(--maxWidth);
  margin-left: auto;
  margin-right: auto;
  padding: 0 var(--space);
}

/* Mobile adjustments */
@media only screen and (max-width: 480px) {
  .nda-text {
    font-size: calc(var(--smallerFontSize) * 0.9);
  }

  .micro-nda--landing .nda-text,
  .micro-nda--mainlongread .nda-text,
  .micro-nda--deeper .nda-text {
    padding: var(--space);
  }
}
</style>
